var $8uLkp$swchelperscjs_await_async_generatorcjs = require("@swc/helpers/cjs/_await_async_generator.cjs");
var $8uLkp$swchelperscjs_call_supercjs = require("@swc/helpers/cjs/_call_super.cjs");
var $8uLkp$swchelperscjs_class_call_checkcjs = require("@swc/helpers/cjs/_class_call_check.cjs");
var $8uLkp$swchelperscjs_inheritscjs = require("@swc/helpers/cjs/_inherits.cjs");
var $8uLkp$swchelperscjs_sliced_to_arraycjs = require("@swc/helpers/cjs/_sliced_to_array.cjs");
var $8uLkp$swchelperscjs_to_consumable_arraycjs = require("@swc/helpers/cjs/_to_consumable_array.cjs");
var $8uLkp$swchelperscjs_type_ofcjs = require("@swc/helpers/cjs/_type_of.cjs");
var $8uLkp$swchelperscjs_wrap_async_generatorcjs = require("@swc/helpers/cjs/_wrap_async_generator.cjs");
var $8uLkp$swchelperscjs_ts_generatorcjs = require("@swc/helpers/cjs/_ts_generator.cjs");
var $8uLkp$swchelperscjs_ts_valuescjs = require("@swc/helpers/cjs/_ts_values.cjs");
var $8uLkp$swchelperscjs_create_classcjs = require("@swc/helpers/cjs/_create_class.cjs");
var $8uLkp$swchelperscjs_getcjs = require("@swc/helpers/cjs/_get.cjs");
var $8uLkp$swchelperscjs_get_prototype_ofcjs = require("@swc/helpers/cjs/_get_prototype_of.cjs");
var $8uLkp$swchelperscjs_async_to_generatorcjs = require("@swc/helpers/cjs/_async_to_generator.cjs");
var $8uLkp$swchelperscjs_object_without_propertiescjs = require("@swc/helpers/cjs/_object_without_properties.cjs");
var $8uLkp$swchelperscjs_object_spreadcjs = require("@swc/helpers/cjs/_object_spread.cjs");
var $8uLkp$swchelperscjs_object_spread_propscjs = require("@swc/helpers/cjs/_object_spread_props.cjs");


function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $46e29b5594bbf78d$exports = {};

$parcel$export($46e29b5594bbf78d$exports, "likeNull", function () { return $46e29b5594bbf78d$export$61cc6ed0f143570b; });
$parcel$export($46e29b5594bbf78d$exports, "isEmpty", function () { return $46e29b5594bbf78d$export$dd1bc94b04021eeb; });
$parcel$export($46e29b5594bbf78d$exports, "classNameOf", function () { return $46e29b5594bbf78d$export$a09f818797e212c4; });
$parcel$export($46e29b5594bbf78d$exports, "assertInheritance", function () { return $46e29b5594bbf78d$export$170f4e08cad8229d; });
$parcel$export($46e29b5594bbf78d$exports, "proxyPrototype", function () { return $46e29b5594bbf78d$export$2a489b3f92f4996a; });
$parcel$export($46e29b5594bbf78d$exports, "isUnsafeNumeric", function () { return $46e29b5594bbf78d$export$67a6ce548ae77071; });
$parcel$export($46e29b5594bbf78d$exports, "byteLength", function () { return $46e29b5594bbf78d$export$a48f0734ac7c2329; });
$parcel$export($46e29b5594bbf78d$exports, "toHyphenCase", function () { return $46e29b5594bbf78d$export$3f34ca2fef821bbd; });
$parcel$export($46e29b5594bbf78d$exports, "toCamelCase", function () { return $46e29b5594bbf78d$export$86f54f62aa7a7514; });
$parcel$export($46e29b5594bbf78d$exports, "uniqueID", function () { return $46e29b5594bbf78d$export$89912e019eef22aa; });
$parcel$export($46e29b5594bbf78d$exports, "objectFrom", function () { return $46e29b5594bbf78d$export$1c8ba402144543e5; });
$parcel$export($46e29b5594bbf78d$exports, "DiffStatus", function () { return $46e29b5594bbf78d$export$2ddabb89308e1a22; });
$parcel$export($46e29b5594bbf78d$exports, "diffKeys", function () { return $46e29b5594bbf78d$export$14527669107aa301; });
$parcel$export($46e29b5594bbf78d$exports, "groupBy", function () { return $46e29b5594bbf78d$export$3f063810d7bf01bd; });
$parcel$export($46e29b5594bbf78d$exports, "likeArray", function () { return $46e29b5594bbf78d$export$b5a4d6f439a5044d; });
$parcel$export($46e29b5594bbf78d$exports, "isTypedArray", function () { return $46e29b5594bbf78d$export$b119cc7e1840e59c; });
$parcel$export($46e29b5594bbf78d$exports, "makeArray", function () { return $46e29b5594bbf78d$export$7b85fd78dd236198; });
$parcel$export($46e29b5594bbf78d$exports, "splitArray", function () { return $46e29b5594bbf78d$export$697c3df919c0e61a; });
$parcel$export($46e29b5594bbf78d$exports, "findDeep", function () { return $46e29b5594bbf78d$export$e6b5ff3168b5942b; });
$parcel$export($46e29b5594bbf78d$exports, "countBy", function () { return $46e29b5594bbf78d$export$1d012a0dff3dab06; });
$parcel$export($46e29b5594bbf78d$exports, "cache", function () { return $46e29b5594bbf78d$export$69a3209f1a06c04d; });
$parcel$export($46e29b5594bbf78d$exports, "createAsyncIterator", function () { return $46e29b5594bbf78d$export$86c18c6347f4a8c4; });
$parcel$export($46e29b5594bbf78d$exports, "mergeStream", function () { return $46e29b5594bbf78d$export$dce9414bed0662c; });
$parcel$export($46e29b5594bbf78d$exports, "ByteSize", function () { return $46e29b5594bbf78d$export$271f7c16f175f804; });










var $5c284d0f856bcfdb$exports = {};

$parcel$export($5c284d0f856bcfdb$exports, "sum", function () { return $5c284d0f856bcfdb$export$8a63f25cc62965f1; });
$parcel$export($5c284d0f856bcfdb$exports, "averageOf", function () { return $5c284d0f856bcfdb$export$e1f36757ecda301d; });
$parcel$export($5c284d0f856bcfdb$exports, "varianceOf", function () { return $5c284d0f856bcfdb$export$8e694e1eafd55acb; });
$parcel$export($5c284d0f856bcfdb$exports, "standardDeviationOf", function () { return $5c284d0f856bcfdb$export$57d7c52a66287430; });
$parcel$export($5c284d0f856bcfdb$exports, "hypotenuseOf", function () { return $5c284d0f856bcfdb$export$2b4693832ca3ce16; });
$parcel$export($5c284d0f856bcfdb$exports, "carryFloat", function () { return $5c284d0f856bcfdb$export$5b784e078da1ce6; });
$parcel$export($5c284d0f856bcfdb$exports, "fixFloat", function () { return $5c284d0f856bcfdb$export$17ec9c9f4f23588c; });
$parcel$export($5c284d0f856bcfdb$exports, "Scalar", function () { return $5c284d0f856bcfdb$export$595dbf49c602a1f; });



function $5c284d0f856bcfdb$export$8a63f25cc62965f1() {
    for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
        data[_key] = arguments[_key];
    }
    return data.reduce(function(sum, item) {
        return sum + item;
    }, 0);
}
function $5c284d0f856bcfdb$export$e1f36757ecda301d() {
    for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
        data[_key] = arguments[_key];
    }
    return $5c284d0f856bcfdb$export$8a63f25cc62965f1.apply(void 0, (0, $8uLkp$swchelperscjs_to_consumable_arraycjs._)(data)) / data.length;
}
function $5c284d0f856bcfdb$export$8e694e1eafd55acb(data) {
    var sample = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var average = $5c284d0f856bcfdb$export$e1f36757ecda301d.apply(void 0, (0, $8uLkp$swchelperscjs_to_consumable_arraycjs._)(data));
    var summary = $5c284d0f856bcfdb$export$8a63f25cc62965f1.apply(void 0, (0, $8uLkp$swchelperscjs_to_consumable_arraycjs._)(data.map(function(item) {
        return Math.pow(item - average, 2);
    })));
    return summary / (data.length - (sample ? 1 : 0));
}
function $5c284d0f856bcfdb$export$57d7c52a66287430(data) {
    var sample = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return Math.sqrt($5c284d0f856bcfdb$export$8e694e1eafd55acb(data, sample));
}
function $5c284d0f856bcfdb$export$2b4693832ca3ce16() {
    for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
        data[_key] = arguments[_key];
    }
    return Math.sqrt($5c284d0f856bcfdb$export$8a63f25cc62965f1.apply(void 0, (0, $8uLkp$swchelperscjs_to_consumable_arraycjs._)(data.map(function(item) {
        return Math.pow(item, 2);
    }))));
}
function $5c284d0f856bcfdb$export$5b784e078da1ce6(raw, length) {
    var text = raw.toFixed(length + 2);
    var offset = text.indexOf('.') + length + 1;
    var cut = function(text) {
        return text.slice(0, offset - (length ? 0 : 1));
    };
    if (!+text.slice(offset)) return cut(text);
    var result = cut((+cut(text) + Math.pow(10, -length)).toFixed(length));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
function $5c284d0f856bcfdb$export$17ec9c9f4f23588c(raw) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var text = raw.toFixed(length + 2);
    var floatOffset = text.indexOf('.');
    if (floatOffset < 0) return length ? "".concat(text, ".").concat('0'.repeat(length)) : text;
    var offset = floatOffset + length + 1;
    var before = +text[offset - 1], anchor = +text[offset], after = +text[offset + 1];
    var carry = anchor > 5 || anchor === 5 && (!!after || !!(before % 2));
    if (carry) return $5c284d0f856bcfdb$export$5b784e078da1ce6(raw, length);
    var result = text.slice(0, offset - (length ? 0 : 1));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
var $5c284d0f856bcfdb$export$595dbf49c602a1f = /*#__PURE__*/ function() {
    "use strict";
    function Scalar(value) {
        (0, $8uLkp$swchelperscjs_class_call_checkcjs._)(this, Scalar);
        this.value = value;
    }
    (0, $8uLkp$swchelperscjs_create_classcjs._)(Scalar, [
        {
            key: "valueOf",
            value: function valueOf() {
                return this.value;
            }
        },
        {
            key: "toShortString",
            value: function toShortString() {
                var fractionDigits = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 2;
                var _this = this, units = _this.units, value = _this.value;
                var _ref = (0, $8uLkp$swchelperscjs_to_consumable_arraycjs._)(units).reverse().find(function(param) {
                    var base = param.base;
                    return Math.abs(value) >= base;
                }) || units[0], base = _ref.base, name = _ref.name;
                return "".concat((value / base).toFixed(fractionDigits), " ").concat(name);
            }
        }
    ], [
        {
            key: "distanceOf",
            value: function distanceOf(a, b) {
                return Reflect.construct(this, [
                    a - b
                ]);
            }
        }
    ]);
    return Scalar;
}();


function $46e29b5594bbf78d$export$61cc6ed0f143570b(value) {
    return !(value != null) || Number.isNaN(value);
}
function $46e29b5594bbf78d$export$dd1bc94b04021eeb(value) {
    return $46e29b5594bbf78d$export$61cc6ed0f143570b(value) || ((typeof value === "undefined" ? "undefined" : (0, $8uLkp$swchelperscjs_type_ofcjs._)(value)) === 'object' ? !Object.keys(value).length : value === '');
}
var $46e29b5594bbf78d$export$a09f818797e212c4 = function(data) {
    return Object.prototype.toString.call(data).slice(8, -1);
};
function $46e29b5594bbf78d$export$170f4e08cad8229d(Sub, Super) {
    return Sub.prototype instanceof Super;
}
function $46e29b5594bbf78d$export$2a489b3f92f4996a(target, dataStore, setter) {
    var prototype = Object.getPrototypeOf(target);
    var prototypeProxy = new Proxy(prototype, {
        set: function(_, key, value, receiver) {
            if (key in receiver) Reflect.set(prototype, key, value, receiver);
            else dataStore[key] = value;
            setter === null || setter === void 0 ? void 0 : setter(key, value);
            return true;
        },
        get: function(prototype, key, receiver) {
            return key in dataStore ? dataStore[key] : Reflect.get(prototype, key, receiver);
        }
    });
    Object.setPrototypeOf(target, prototypeProxy);
}
function $46e29b5594bbf78d$export$67a6ce548ae77071(raw) {
    return /^[\d.]+$/.test(raw) && raw.localeCompare(Number.MAX_SAFE_INTEGER + '', undefined, {
        numeric: true
    }) > 0;
}
function $46e29b5594bbf78d$export$a48f0734ac7c2329(raw) {
    return raw.replace(/[^\u0021-\u007e\uff61-\uffef]/g, 'xx').length;
}
function $46e29b5594bbf78d$export$3f34ca2fef821bbd(raw) {
    return raw.replace(/[A-Z]+|[^A-Za-z][A-Za-z]/g, function(match, offset) {
        return "".concat(offset ? '-' : '').concat((match[1] || match[0]).toLowerCase());
    });
}
function $46e29b5594bbf78d$export$86f54f62aa7a7514(raw) {
    var large = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return raw.replace(/^[A-Za-z]|[^A-Za-z][A-Za-z]/g, function(match, offset) {
        return offset || large ? (match[1] || match[0]).toUpperCase() : match.toLowerCase();
    });
}
function $46e29b5594bbf78d$export$89912e019eef22aa() {
    return (Date.now() + parseInt((Math.random() + '').slice(2))).toString(36);
}
function $46e29b5594bbf78d$export$1c8ba402144543e5(values, keys) {
    return Object.fromEntries(values.map(function(value, index) {
        return [
            keys[index],
            value
        ];
    }));
}
var $46e29b5594bbf78d$export$2ddabb89308e1a22 = /*#__PURE__*/ function(DiffStatus) {
    DiffStatus[DiffStatus["Old"] = -1] = "Old";
    DiffStatus[DiffStatus["Same"] = 0] = "Same";
    DiffStatus[DiffStatus["New"] = 1] = "New";
    return DiffStatus;
}({});
function $46e29b5594bbf78d$export$14527669107aa301(oldList, newList) {
    var map = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = oldList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            map[item] = -1;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = newList[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var item1 = _step1.value;
            var _map, _item;
            (_map = map)[_item = item1] || (_map[_item] = 0);
            map[item1] += 1;
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return {
        map: map,
        group: $46e29b5594bbf78d$export$3f063810d7bf01bd(Object.entries(map), function(param) {
            var _param = (0, $8uLkp$swchelperscjs_sliced_to_arraycjs._)(param, 2), key = _param[0], status = _param[1];
            return status;
        })
    };
}
function $46e29b5594bbf78d$export$b5a4d6f439a5044d(data) {
    if ($46e29b5594bbf78d$export$61cc6ed0f143570b(data)) return false;
    var length = data.length;
    return typeof length === 'number' && length >= 0 && ~~length === length;
}
var $46e29b5594bbf78d$export$b119cc7e1840e59c = function(data) {
    return data instanceof Object.getPrototypeOf(Int8Array);
};
function $46e29b5594bbf78d$export$7b85fd78dd236198(data) {
    if (data instanceof Array) return data;
    if ($46e29b5594bbf78d$export$61cc6ed0f143570b(data)) return [];
    if ($46e29b5594bbf78d$export$b5a4d6f439a5044d(data)) return Array.from(data);
    return [
        data
    ];
}
var $46e29b5594bbf78d$export$697c3df919c0e61a = function(array, unitLength) {
    return array.reduce(function(grid, item, index) {
        var _grid, _ref;
        ((_grid = grid)[_ref = ~~(index / unitLength)] || (_grid[_ref] = []))[index % unitLength] = item;
        return grid;
    }, []);
};
function $46e29b5594bbf78d$export$e6b5ff3168b5942b(list, subKey, handler) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (handler(item)) return [
                item
            ];
            if (item[subKey] instanceof Array) {
                var result = $46e29b5594bbf78d$export$e6b5ff3168b5942b(item[subKey], subKey, handler);
                if (result.length) return [
                    item
                ].concat((0, $8uLkp$swchelperscjs_to_consumable_arraycjs._)(result));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [];
}
function $46e29b5594bbf78d$export$3f063810d7bf01bd(list, iteratee) {
    var data = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var keys = iteratee instanceof Function ? iteratee(item) : item[iteratee];
            if (!(keys instanceof Array)) keys = [
                keys
            ];
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = new Set(keys.filter(function(key) {
                    return key != null;
                }))[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var key = _step1.value;
                    (data[key] = data[key] || []).push(item);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return data;
}
function $46e29b5594bbf78d$export$1d012a0dff3dab06(list, iteratee) {
    var group = $46e29b5594bbf78d$export$3f063810d7bf01bd(list, iteratee);
    var sortedList = Object.entries(group).map(function(param) {
        var _param = (0, $8uLkp$swchelperscjs_sliced_to_arraycjs._)(param, 2), key = _param[0], length = _param[1].length;
        return [
            key,
            length
        ];
    });
    return Object.fromEntries(sortedList);
}
function $46e29b5594bbf78d$export$69a3209f1a06c04d(executor, title) {
    var cacheData;
    return function() {
        for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
            data[_key] = arguments[_key];
        }
        var _executor;
        if (cacheData != null) return cacheData;
        console.trace("[Cache] execute: ".concat(title));
        cacheData = (_executor = executor).call.apply(_executor, [
            this,
            function() {
                return cacheData = undefined;
            }
        ].concat((0, $8uLkp$swchelperscjs_to_consumable_arraycjs._)(data)));
        Promise.resolve(cacheData).then(function(data) {
            return console.log("[Cache] refreshed: ".concat(title, " => ").concat(data));
        }, function(error) {
            return console.error("[Cache] failed: ".concat((error === null || error === void 0 ? void 0 : error.message) || error));
        });
        return cacheData;
    };
}
function $46e29b5594bbf78d$export$86c18c6347f4a8c4(executor) {
    return $46e29b5594bbf78d$var$_createAsyncIterator.apply(this, arguments);
}
function $46e29b5594bbf78d$var$_createAsyncIterator() {
    $46e29b5594bbf78d$var$_createAsyncIterator = (0, $8uLkp$swchelperscjs_wrap_async_generatorcjs._)(function(executor) {
        var _Promise_withResolvers, promise, resolve, reject, doneSymbol, done, disposer, value, ref;
        return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _Promise_withResolvers = Promise.withResolvers(), promise = _Promise_withResolvers.promise, resolve = _Promise_withResolvers.resolve, reject = _Promise_withResolvers.reject;
                    doneSymbol = Symbol('done'), done = Promise.withResolvers();
                    disposer = executor({
                        next: function(value) {
                            return resolve(value);
                        },
                        error: function(error) {
                            reject(error);
                            // @ts-ignore
                            disposer === null || disposer === void 0 ? void 0 : disposer();
                        },
                        complete: function() {
                            done.resolve(doneSymbol);
                            // @ts-ignore
                            disposer === null || disposer === void 0 ? void 0 : disposer();
                        }
                    });
                    _state.label = 1;
                case 1:
                    if (!true) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        (0, $8uLkp$swchelperscjs_await_async_generatorcjs._)(Promise.race([
                            promise,
                            done.promise
                        ]))
                    ];
                case 2:
                    value = _state.sent();
                    if (value === doneSymbol) return [
                        2
                    ];
                    return [
                        4,
                        value
                    ];
                case 3:
                    _state.sent();
                    ref = Promise.withResolvers(), promise = ref.promise, resolve = ref.resolve, reject = ref.reject, ref;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $46e29b5594bbf78d$var$_createAsyncIterator.apply(this, arguments);
}
function $46e29b5594bbf78d$export$dce9414bed0662c() {
    return $46e29b5594bbf78d$var$_mergeStream.apply(this, arguments);
}
function $46e29b5594bbf78d$var$_mergeStream() {
    $46e29b5594bbf78d$var$_mergeStream = (0, $8uLkp$swchelperscjs_wrap_async_generatorcjs._)(function() {
        var _loop, _len, sources, _key, iterators;
        var _arguments = arguments;
        return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function() {
                        var dones, i, iterator, _ref, done, value;
                        return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    dones = [];
                                    i = 0, iterator = void 0;
                                    _state.label = 1;
                                case 1:
                                    if (!(iterator = iterators[i])) return [
                                        3,
                                        6
                                    ];
                                    return [
                                        4,
                                        (0, $8uLkp$swchelperscjs_await_async_generatorcjs._)(iterator.next())
                                    ];
                                case 2:
                                    _ref = _state.sent(), done = _ref.done, value = _ref.value;
                                    if (!!done) return [
                                        3,
                                        4
                                    ];
                                    return [
                                        4,
                                        value
                                    ];
                                case 3:
                                    _state.sent();
                                    return [
                                        3,
                                        5
                                    ];
                                case 4:
                                    dones.push(i);
                                    _state.label = 5;
                                case 5:
                                    i++;
                                    return [
                                        3,
                                        1
                                    ];
                                case 6:
                                    iterators = iterators.filter(function(_, i) {
                                        return !dones.includes(i);
                                    });
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    for(_len = _arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++){
                        sources[_key] = _arguments[_key];
                    }
                    iterators = sources.map(function(item) {
                        return item();
                    });
                    _state.label = 1;
                case 1:
                    if (!iterators[0]) return [
                        3,
                        3
                    ];
                    return [
                        5,
                        (0, $8uLkp$swchelperscjs_ts_valuescjs._)(_loop())
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $46e29b5594bbf78d$var$_mergeStream.apply(this, arguments);
}
var $46e29b5594bbf78d$export$271f7c16f175f804 = /*#__PURE__*/ function(Scalar) {
    "use strict";
    (0, $8uLkp$swchelperscjs_inheritscjs._)(ByteSize, Scalar);
    function ByteSize() {
        (0, $8uLkp$swchelperscjs_class_call_checkcjs._)(this, ByteSize);
        var _this;
        _this = (0, $8uLkp$swchelperscjs_call_supercjs._)(this, ByteSize, arguments), _this.units = [
            '',
            'K',
            'M',
            'G',
            'T',
            'P',
            'E',
            'Z',
            'Y'
        ].map(function(name, i) {
            return {
                base: Math.pow(1024, i),
                name: name + 'B'
            };
        });
        return _this;
    }
    return ByteSize;
}((0, $5c284d0f856bcfdb$export$595dbf49c602a1f));



var $2f62b288a8aa0302$exports = {};

$parcel$export($2f62b288a8aa0302$exports, "Second", function () { return $2f62b288a8aa0302$export$c489aa6f7fd82b1a; });
$parcel$export($2f62b288a8aa0302$exports, "Minute", function () { return $2f62b288a8aa0302$export$cbd942915f33be50; });
$parcel$export($2f62b288a8aa0302$exports, "Quarter", function () { return $2f62b288a8aa0302$export$9b886f8493244014; });
$parcel$export($2f62b288a8aa0302$exports, "Hour", function () { return $2f62b288a8aa0302$export$e99cbb807a5bb10d; });
$parcel$export($2f62b288a8aa0302$exports, "Day", function () { return $2f62b288a8aa0302$export$7a9a31a911eb9a20; });
$parcel$export($2f62b288a8aa0302$exports, "Week", function () { return $2f62b288a8aa0302$export$fca4f8121099df57; });
$parcel$export($2f62b288a8aa0302$exports, "Year", function () { return $2f62b288a8aa0302$export$6ce2f08d515512; });
$parcel$export($2f62b288a8aa0302$exports, "Month", function () { return $2f62b288a8aa0302$export$951c8378cdfec6e6; });
$parcel$export($2f62b288a8aa0302$exports, "Season", function () { return $2f62b288a8aa0302$export$1a4097b876a13bf7; });
$parcel$export($2f62b288a8aa0302$exports, "Timestamp", function () { return $2f62b288a8aa0302$export$d9bcbd5e1ff81430; });
$parcel$export($2f62b288a8aa0302$exports, "diffTime", function () { return $2f62b288a8aa0302$export$506c8e8f8c8edda; });
$parcel$export($2f62b288a8aa0302$exports, "formatDate", function () { return $2f62b288a8aa0302$export$3ae94a2503e890a1; });
$parcel$export($2f62b288a8aa0302$exports, "changeMonth", function () { return $2f62b288a8aa0302$export$62ad822b3a5fd9a0; });








var $2f62b288a8aa0302$export$c489aa6f7fd82b1a = 1000;
var $2f62b288a8aa0302$export$cbd942915f33be50 = $2f62b288a8aa0302$export$c489aa6f7fd82b1a * 60;
var $2f62b288a8aa0302$export$9b886f8493244014 = $2f62b288a8aa0302$export$cbd942915f33be50 * 15;
var $2f62b288a8aa0302$export$e99cbb807a5bb10d = $2f62b288a8aa0302$export$9b886f8493244014 * 4;
var $2f62b288a8aa0302$export$7a9a31a911eb9a20 = $2f62b288a8aa0302$export$e99cbb807a5bb10d * 24;
var $2f62b288a8aa0302$export$fca4f8121099df57 = $2f62b288a8aa0302$export$7a9a31a911eb9a20 * 7;
var $2f62b288a8aa0302$export$6ce2f08d515512 = $2f62b288a8aa0302$export$7a9a31a911eb9a20 * 365;
var $2f62b288a8aa0302$export$951c8378cdfec6e6 = $2f62b288a8aa0302$export$6ce2f08d515512 / 12;
var $2f62b288a8aa0302$export$1a4097b876a13bf7 = $2f62b288a8aa0302$export$951c8378cdfec6e6 * 3;
var $2f62b288a8aa0302$export$d9bcbd5e1ff81430 = /*#__PURE__*/ function(Scalar) {
    "use strict";
    (0, $8uLkp$swchelperscjs_inheritscjs._)(Timestamp, Scalar);
    function Timestamp() {
        (0, $8uLkp$swchelperscjs_class_call_checkcjs._)(this, Timestamp);
        var _this;
        _this = (0, $8uLkp$swchelperscjs_call_supercjs._)(this, Timestamp, arguments), _this.units = [
            {
                base: $2f62b288a8aa0302$export$c489aa6f7fd82b1a,
                name: 's'
            },
            {
                base: $2f62b288a8aa0302$export$cbd942915f33be50,
                name: 'm'
            },
            {
                base: $2f62b288a8aa0302$export$e99cbb807a5bb10d,
                name: 'H'
            },
            {
                base: $2f62b288a8aa0302$export$7a9a31a911eb9a20,
                name: 'D'
            },
            {
                base: $2f62b288a8aa0302$export$fca4f8121099df57,
                name: 'W'
            },
            {
                base: $2f62b288a8aa0302$export$951c8378cdfec6e6,
                name: 'M'
            },
            {
                base: $2f62b288a8aa0302$export$6ce2f08d515512,
                name: 'Y'
            }
        ];
        return _this;
    }
    (0, $8uLkp$swchelperscjs_create_classcjs._)(Timestamp, [
        {
            key: "toShortString",
            value: function toShortString() {
                var fractionDigits = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                return (0, $8uLkp$swchelperscjs_getcjs._)((0, $8uLkp$swchelperscjs_get_prototype_ofcjs._)(Timestamp.prototype), "toShortString", this).call(this, fractionDigits);
            }
        }
    ]);
    return Timestamp;
}((0, $5c284d0f856bcfdb$export$595dbf49c602a1f));
function $2f62b288a8aa0302$export$506c8e8f8c8edda(end) {
    var start = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date();
    var timeDistance = $2f62b288a8aa0302$export$d9bcbd5e1ff81430.distanceOf(+new Date(end), +new Date(start));
    var _timeDistance_toShortString_split = (0, $8uLkp$swchelperscjs_sliced_to_arraycjs._)(timeDistance.toShortString().split(/\s+/), 2), value = _timeDistance_toShortString_split[0], unit = _timeDistance_toShortString_split[1];
    return {
        distance: +value,
        unit: unit
    };
}
function $2f62b288a8aa0302$var$fitUnit(value) {
    value = +value + '';
    return function(template) {
        return (value.length < template.length ? value.padStart(template.length, '0') : value).slice(-Math.max(template.length, 2));
    };
}
function $2f62b288a8aa0302$export$3ae94a2503e890a1() {
    var time = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date(), template = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';
    time = time instanceof Date ? time : new Date(time);
    time = new Date(+time - time.getTimezoneOffset() * $2f62b288a8aa0302$export$cbd942915f33be50);
    var _time_toJSON_split = (0, $8uLkp$swchelperscjs_sliced_to_arraycjs._)(time.toJSON().split(/\D/), 7), year = _time_toJSON_split[0], month = _time_toJSON_split[1], day = _time_toJSON_split[2], hour = _time_toJSON_split[3], minute = _time_toJSON_split[4], second = _time_toJSON_split[5], millisecond = _time_toJSON_split[6];
    return template.replace(/ms/g, millisecond).replace(/Y+/g, $2f62b288a8aa0302$var$fitUnit(year)).replace(/M+/g, $2f62b288a8aa0302$var$fitUnit(month)).replace(/D+/g, $2f62b288a8aa0302$var$fitUnit(day)).replace(/H+/g, $2f62b288a8aa0302$var$fitUnit(hour)).replace(/m+/g, $2f62b288a8aa0302$var$fitUnit(minute)).replace(/s+/g, $2f62b288a8aa0302$var$fitUnit(second));
}
function $2f62b288a8aa0302$export$62ad822b3a5fd9a0(date, delta) {
    date = new Date(date);
    var month = date.getMonth() + delta;
    date.setFullYear(date.getFullYear() + Math.floor(month / 12));
    delta = month % 12;
    date.setMonth(delta < 0 ? 12 + delta : delta);
    return date;
}


var $e1fee001b184ad77$exports = {};

$parcel$export($e1fee001b184ad77$exports, "parseJSON", function () { return $e1fee001b184ad77$export$27924e57e9afff7f; });
$parcel$export($e1fee001b184ad77$exports, "toJSValue", function () { return $e1fee001b184ad77$export$7ea17d45ecdcf634; });
$parcel$export($e1fee001b184ad77$exports, "parseTextTable", function () { return $e1fee001b184ad77$export$bb8626e4916f587b; });

function $e1fee001b184ad77$export$27924e57e9afff7f(raw) {
    function parseItem(value) {
        if (typeof value === 'string' && /^\d+(-\d{1,2}){1,2}/.test(value)) {
            var date = new Date(value);
            if (!Number.isNaN(+date)) return date;
        }
        return value;
    }
    var value = parseItem(raw);
    if (typeof value !== 'string' || (0, $46e29b5594bbf78d$export$67a6ce548ae77071)(value)) return value;
    try {
        return JSON.parse(raw, function(key, value) {
            return parseItem(value);
        });
    } catch (e) {
        return raw;
    }
}
function $e1fee001b184ad77$export$7ea17d45ecdcf634(raw) {
    var parsed = $e1fee001b184ad77$export$27924e57e9afff7f(raw);
    if (typeof parsed !== 'string') return parsed;
    var number = +parsed;
    return Number.isNaN(number) || number + '' !== parsed ? parsed : number;
}
function $e1fee001b184ad77$var$readQuoteValue(raw) {
    var quote = raw[0];
    var index = raw.indexOf(quote, 1);
    if (index < 0) throw SyntaxError("A ".concat(quote, " is missing"));
    return raw.slice(1, index);
}
function $e1fee001b184ad77$export$bb8626e4916f587b(raw, header) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ',';
    var data = raw.trim().split(/[\r\n]+/).map(function(row) {
        var list = [];
        do {
            var value = void 0;
            if (row[0] === '"' || row[0] === "'") {
                value = $e1fee001b184ad77$var$readQuoteValue(row);
                row = row.slice(value.length + 3);
            } else {
                var index = row.indexOf(separator);
                if (index > -1) {
                    value = row.slice(0, index);
                    row = row.slice(index + 1);
                } else {
                    value = row;
                    row = '';
                }
            }
            list.push($e1fee001b184ad77$export$7ea17d45ecdcf634(value.trim()));
        }while (row);
        return list;
    });
    return !header ? data : data.slice(1).map(function(row) {
        return row.reduce(function(object, item, index) {
            object[data[0][index]] = item;
            return object;
        }, {});
    });
}


var $c935a86b3659bb42$exports = {};

$parcel$export($c935a86b3659bb42$exports, "isXDomain", function () { return $c935a86b3659bb42$export$71e6483fc2b024eb; });
$parcel$export($c935a86b3659bb42$exports, "parseURLData", function () { return $c935a86b3659bb42$export$eb9b2aadbe449a20; });
$parcel$export($c935a86b3659bb42$exports, "buildURLData", function () { return $c935a86b3659bb42$export$13397a83aa5915d6; });
$parcel$export($c935a86b3659bb42$exports, "blobOf", function () { return $c935a86b3659bb42$export$fd89523fba250fa4; });
$parcel$export($c935a86b3659bb42$exports, "blobFrom", function () { return $c935a86b3659bb42$export$504fbde693c1771c; });






function $c935a86b3659bb42$export$71e6483fc2b024eb(URI) {
    return new URL(URI, document.baseURI).origin !== location.origin;
}
function $c935a86b3659bb42$export$eb9b2aadbe449a20() {
    var raw = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
        var _globalThis_location;
        return (_globalThis_location = globalThis.location) === null || _globalThis_location === void 0 ? void 0 : _globalThis_location.search;
    }(), toBuiltIn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var rawData = raw.split('#').map(function(URI) {
        var _URI_split = (0, $8uLkp$swchelperscjs_sliced_to_arraycjs._)(URI.split('?'), 2), before = _URI_split[0], after = _URI_split[1];
        return new URLSearchParams(after || (before.includes('=') ? before : ''));
    }).join('&');
    var data = new URLSearchParams(rawData);
    return Object.fromEntries((0, $8uLkp$swchelperscjs_to_consumable_arraycjs._)(data.keys()).map(function(key) {
        var list = toBuiltIn ? data.getAll(key).map((0, $e1fee001b184ad77$export$27924e57e9afff7f)) : data.getAll(key);
        return [
            key,
            list.length < 2 ? list[0] : list
        ];
    }));
}
var $c935a86b3659bb42$var$stringify = function(value) {
    return typeof value === 'string' ? value : (0, $46e29b5594bbf78d$export$b5a4d6f439a5044d)(value) ? (0, $46e29b5594bbf78d$export$7b85fd78dd236198)(value) + '' : JSON.stringify(value);
};
function $c935a86b3659bb42$export$13397a83aa5915d6(map) {
    if (!(map instanceof Array)) map = Object.entries(map);
    var list = map.map(function(param) {
        var _param = (0, $8uLkp$swchelperscjs_sliced_to_arraycjs._)(param, 2), key = _param[0], value = _param[1];
        return !(0, $46e29b5594bbf78d$export$dd1bc94b04021eeb)(value) && [
            key,
            $c935a86b3659bb42$var$stringify(value)
        ];
    }).filter(Boolean);
    return new URLSearchParams(list);
}
function $c935a86b3659bb42$export$fd89523fba250fa4(URI) {
    return $c935a86b3659bb42$var$_blobOf.apply(this, arguments);
}
function $c935a86b3659bb42$var$_blobOf() {
    $c935a86b3659bb42$var$_blobOf = (0, $8uLkp$swchelperscjs_async_to_generatorcjs._)(function(URI) {
        return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch(URI + '')
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().blob()
                    ];
            }
        });
    });
    return $c935a86b3659bb42$var$_blobOf.apply(this, arguments);
}
var $c935a86b3659bb42$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
function $c935a86b3659bb42$export$504fbde693c1771c(URI) {
    var _ref = (0, $8uLkp$swchelperscjs_sliced_to_arraycjs._)($c935a86b3659bb42$var$DataURI.exec(URI) || [], 5), _ = _ref[0], type = _ref[1], __ = _ref[2], base64 = _ref[3], data = _ref[4];
    data = base64 ? atob(data) : data;
    var aBuffer = new ArrayBuffer(data.length);
    var uBuffer = new Uint8Array(aBuffer);
    for(var i = 0; data[i]; i++)uBuffer[i] = data.charCodeAt(i);
    return new Blob([
        aBuffer
    ], {
        type: type
    });
}


var $5b42b1dfba5d48a1$exports = {};

$parcel$export($5b42b1dfba5d48a1$exports, "makeCRC32", function () { return $5b42b1dfba5d48a1$export$1b9ac4d3de3ffd2e; });
$parcel$export($5b42b1dfba5d48a1$exports, "makeSHA", function () { return $5b42b1dfba5d48a1$export$d51f3b55e8d1aa73; });



var $5b42b1dfba5d48a1$var$CRC_32_Table = Array.from(new Array(256), function(_, cell) {
    for(var j = 0; j < 8; j++)if (cell & 1) cell = cell >> 1 & 0x7fffffff ^ 0xedb88320;
    else cell = cell >> 1 & 0x7fffffff;
    return cell;
});
function $5b42b1dfba5d48a1$export$1b9ac4d3de3ffd2e(raw) {
    var value = 0xffffffff;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = raw[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var char = _step.value;
            value = value >> 8 & 0x00ffffff ^ $5b42b1dfba5d48a1$var$CRC_32_Table[value & 0xff ^ char.charCodeAt(0)];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return '0x' + ((value ^ 0xffffffff) >>> 0).toString(16);
}
if ((typeof self === "undefined" ? "undefined" : (0, $8uLkp$swchelperscjs_type_ofcjs._)(self)) === 'object') {
    if ('msCrypto' in globalThis) {
        var $5b42b1dfba5d48a1$var$_loop = function(key) {
            var origin = $5b42b1dfba5d48a1$var$subtle[key];
            if (origin instanceof Function) $5b42b1dfba5d48a1$var$subtle[key] = function() {
                var observer = origin.apply(this, arguments);
                return new Promise(function(resolve, reject) {
                    observer.oncomplete = function(param) {
                        var target = param.target;
                        return resolve(target.result);
                    };
                    observer.onabort = observer.onerror = reject;
                });
            };
        };
        // @ts-ignore
        var $5b42b1dfba5d48a1$var$subtle = (globalThis.crypto = globalThis.msCrypto).subtle;
        for(var $5b42b1dfba5d48a1$var$key in $5b42b1dfba5d48a1$var$subtle)$5b42b1dfba5d48a1$var$_loop($5b42b1dfba5d48a1$var$key);
    }
    var $5b42b1dfba5d48a1$var$crypto1 = globalThis.crypto;
    if (!($5b42b1dfba5d48a1$var$crypto1 === null || $5b42b1dfba5d48a1$var$crypto1 === void 0 ? void 0 : $5b42b1dfba5d48a1$var$crypto1.subtle) && ($5b42b1dfba5d48a1$var$crypto1 === null || $5b42b1dfba5d48a1$var$crypto1 === void 0 ? void 0 : $5b42b1dfba5d48a1$var$crypto1['webkitSubtle'])) // @ts-ignore
    $5b42b1dfba5d48a1$var$crypto1.subtle = $5b42b1dfba5d48a1$var$crypto1['webkitSubtle'];
}
function $5b42b1dfba5d48a1$export$d51f3b55e8d1aa73(raw) {
    return $5b42b1dfba5d48a1$var$_makeSHA.apply(this, arguments);
}
function $5b42b1dfba5d48a1$var$_makeSHA() {
    $5b42b1dfba5d48a1$var$_makeSHA = (0, $8uLkp$swchelperscjs_async_to_generatorcjs._)(function(raw) {
        var algorithm, buffer;
        var _arguments = arguments;
        return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    algorithm = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 'SHA-1';
                    return [
                        4,
                        crypto.subtle.digest(algorithm, new TextEncoder().encode(raw))
                    ];
                case 1:
                    buffer = _state.sent();
                    return [
                        2,
                        Array.from(new Uint8Array(buffer), function(byte) {
                            return byte.toString(16).padStart(2, '0');
                        }).join('')
                    ];
            }
        });
    });
    return $5b42b1dfba5d48a1$var$_makeSHA.apply(this, arguments);
}


var $7ca3f16dcbfed4a9$exports = {};


var $9046fa14dd22ab7f$exports = {};

$parcel$export($9046fa14dd22ab7f$exports, "XMLNamespace", function () { return $9046fa14dd22ab7f$export$f5a4056b78c72efa; });
$parcel$export($9046fa14dd22ab7f$exports, "templateOf", function () { return $9046fa14dd22ab7f$export$2ee022bbbc550b25; });
$parcel$export($9046fa14dd22ab7f$exports, "elementTypeOf", function () { return $9046fa14dd22ab7f$export$a549dd5cef7f8327; });
$parcel$export($9046fa14dd22ab7f$exports, "isHTMLElementClass", function () { return $9046fa14dd22ab7f$export$8eece510bcb9c62c; });
$parcel$export($9046fa14dd22ab7f$exports, "tagNameOf", function () { return $9046fa14dd22ab7f$export$b8a1af58c024fefd; });
$parcel$export($9046fa14dd22ab7f$exports, "isDOMReadOnly", function () { return $9046fa14dd22ab7f$export$a2cf0d4bb6e06de4; });
$parcel$export($9046fa14dd22ab7f$exports, "parseDOM", function () { return $9046fa14dd22ab7f$export$d66b332881d9723f; });
$parcel$export($9046fa14dd22ab7f$exports, "stringifyDOM", function () { return $9046fa14dd22ab7f$export$b0709844452f8b6b; });
$parcel$export($9046fa14dd22ab7f$exports, "walkDOM", function () { return $9046fa14dd22ab7f$export$5118471ee5d5453b; });
$parcel$export($9046fa14dd22ab7f$exports, "getVisibleText", function () { return $9046fa14dd22ab7f$export$be4650432daa84fd; });
$parcel$export($9046fa14dd22ab7f$exports, "splitPages", function () { return $9046fa14dd22ab7f$export$578e38b4a3e0b255; });
$parcel$export($9046fa14dd22ab7f$exports, "importCSS", function () { return $9046fa14dd22ab7f$export$7cd14c57bbb84350; });
$parcel$export($9046fa14dd22ab7f$exports, "stringifyCSS", function () { return $9046fa14dd22ab7f$export$5100419dfae0456d; });
$parcel$export($9046fa14dd22ab7f$exports, "insertToCursor", function () { return $9046fa14dd22ab7f$export$28d9d24a8cd0ffc2; });
$parcel$export($9046fa14dd22ab7f$exports, "scrollTo", function () { return $9046fa14dd22ab7f$export$3f99968195accfaf; });
$parcel$export($9046fa14dd22ab7f$exports, "watchScroll", function () { return $9046fa14dd22ab7f$export$eafdbaa868ea9975; });
$parcel$export($9046fa14dd22ab7f$exports, "watchVisible", function () { return $9046fa14dd22ab7f$export$36a0c1ca2ae264fa; });
$parcel$export($9046fa14dd22ab7f$exports, "formToJSON", function () { return $9046fa14dd22ab7f$export$86d7c59254d6a2c9; });








var $9046fa14dd22ab7f$export$f5a4056b78c72efa = {
    html: 'http://www.w3.org/1999/xhtml',
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
};
var $9046fa14dd22ab7f$var$templateMap = {};
function $9046fa14dd22ab7f$export$2ee022bbbc550b25(tagName) {
    if ($9046fa14dd22ab7f$var$templateMap[tagName]) return $9046fa14dd22ab7f$var$templateMap[tagName];
    var spawn = document.createElement('template');
    spawn.innerHTML = "<".concat(tagName, " />");
    return $9046fa14dd22ab7f$var$templateMap[tagName] = spawn.content.firstElementChild;
}
function $9046fa14dd22ab7f$export$a549dd5cef7f8327(tagName) {
    if (tagName.includes('-')) return 'html';
    var _tagName_split = (0, $8uLkp$swchelperscjs_sliced_to_arraycjs._)(tagName.split(':'), 2), prefix = _tagName_split[0], localName = _tagName_split[1];
    if (localName) return prefix === 'html' ? 'html' : 'xml';
    var node = $9046fa14dd22ab7f$export$2ee022bbbc550b25(tagName);
    return node instanceof HTMLElement && !(node instanceof HTMLUnknownElement) ? 'html' : 'xml';
}
function $9046fa14dd22ab7f$export$8eece510bcb9c62c(Class) {
    return (0, $46e29b5594bbf78d$export$170f4e08cad8229d)(Class, HTMLElement);
}
var $9046fa14dd22ab7f$var$nameMap = new WeakMap();
function $9046fa14dd22ab7f$export$b8a1af58c024fefd(Class) {
    var name = $9046fa14dd22ab7f$var$nameMap.get(Class);
    if (name) return name;
    var tagName = new Class().tagName;
    $9046fa14dd22ab7f$var$nameMap.set(Class, tagName = tagName.toLowerCase());
    return tagName;
}
function $9046fa14dd22ab7f$export$a2cf0d4bb6e06de4(tagName, propertyName) {
    /**
     * fetch from https://html.spec.whatwg.org/
     */ var ReadOnly_Properties = [
        [
            HTMLLinkElement,
            [
                'sizes'
            ]
        ],
        [
            HTMLIFrameElement,
            [
                'sandbox'
            ]
        ],
        [
            HTMLObjectElement,
            [
                'form'
            ]
        ],
        [
            HTMLInputElement,
            [
                'form',
                'list'
            ]
        ],
        [
            HTMLButtonElement,
            [
                'form'
            ]
        ],
        [
            HTMLSelectElement,
            [
                'form'
            ]
        ],
        [
            HTMLTextAreaElement,
            [
                'form'
            ]
        ],
        [
            HTMLOutputElement,
            [
                'form'
            ]
        ],
        [
            HTMLFieldSetElement,
            [
                'form'
            ]
        ]
    ];
    var template = $9046fa14dd22ab7f$export$2ee022bbbc550b25(tagName);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ReadOnly_Properties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $8uLkp$swchelperscjs_sliced_to_arraycjs._)(_step.value, 2), Class = _step_value[0], keys = _step_value[1];
            if (template instanceof Class && keys.includes(propertyName)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $9046fa14dd22ab7f$export$d66b332881d9723f(HTML) {
    var spawn = document.createElement('template');
    spawn.innerHTML = HTML;
    return (0, $8uLkp$swchelperscjs_to_consumable_arraycjs._)(spawn.content.childNodes).map(function(node) {
        node.remove();
        return node;
    });
}
function $9046fa14dd22ab7f$export$b0709844452f8b6b(node) {
    return new XMLSerializer().serializeToString(node).replace(/ xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, '');
}
function $9046fa14dd22ab7f$export$5118471ee5d5453b(root, type) {
    var children, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, node, err;
    return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
        switch(_state.label){
            case 0:
                children = (0, $8uLkp$swchelperscjs_to_consumable_arraycjs._)(root.childNodes);
                if (!((0, $46e29b5594bbf78d$export$dd1bc94b04021eeb)(type) || type === root.nodeType)) return [
                    3,
                    2
                ];
                return [
                    4,
                    root
                ];
            case 1:
                _state.sent();
                _state.label = 2;
            case 2:
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                _state.label = 3;
            case 3:
                _state.trys.push([
                    3,
                    8,
                    9,
                    10
                ]);
                _iterator = children[Symbol.iterator]();
                _state.label = 4;
            case 4:
                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                    3,
                    7
                ];
                node = _step.value;
                return [
                    5,
                    (0, $8uLkp$swchelperscjs_ts_valuescjs._)($9046fa14dd22ab7f$export$5118471ee5d5453b(node, type))
                ];
            case 5:
                _state.sent();
                _state.label = 6;
            case 6:
                _iteratorNormalCompletion = true;
                return [
                    3,
                    4
                ];
            case 7:
                return [
                    3,
                    10
                ];
            case 8:
                err = _state.sent();
                _didIteratorError = true;
                _iteratorError = err;
                return [
                    3,
                    10
                ];
            case 9:
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
                return [
                    7
                ];
            case 10:
                return [
                    2
                ];
        }
    });
}
function $9046fa14dd22ab7f$export$be4650432daa84fd(root) {
    var text = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $9046fa14dd22ab7f$export$5118471ee5d5453b(root)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, nodeType = _step_value.nodeType, parentElement = _step_value.parentElement, nodeValue = _step_value.nodeValue;
            if (nodeType === Node.TEXT_NODE && parentElement.getAttribute('aria-hidden') !== 'true') {
                var _parentElement_getBoundingClientRect = parentElement.getBoundingClientRect(), width = _parentElement_getBoundingClientRect.width, height = _parentElement_getBoundingClientRect.height;
                if (width && height) text += nodeValue.trim().replace(/\s+/g, ' ');
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return text;
}
function $9046fa14dd22ab7f$export$578e38b4a3e0b255(param) {
    var offsetWidth = param.offsetWidth, children = param.children, pageHeight = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 841.89, pageWidth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 595.28;
    var scrollHeight = pageHeight / pageWidth * offsetWidth;
    var offset = 0;
    return (0, $8uLkp$swchelperscjs_to_consumable_arraycjs._)(children).reduce(function(pages, node) {
        var _pages, _bottomIndex;
        var top = node.offsetTop, height = node.offsetHeight;
        top += offset;
        var bottom = top + height;
        var bottomOffset = bottom / scrollHeight;
        var topIndex = ~~(top / scrollHeight), bottomIndex = ~~bottomOffset;
        if (topIndex !== bottomIndex) offset += height - bottomOffset;
        ((_pages = pages)[_bottomIndex = bottomIndex] || (_pages[_bottomIndex] = [])).push(node);
        return pages;
    }, []);
}
function $9046fa14dd22ab7f$export$7cd14c57bbb84350(URI) {
    var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var alternate = _param.alternate, options = (0, $8uLkp$swchelperscjs_object_without_propertiescjs._)(_param, [
        "alternate"
    ]);
    var style = (0, $8uLkp$swchelperscjs_to_consumable_arraycjs._)(document.styleSheets).find(function(param) {
        var href = param.href;
        return href === URI;
    });
    if (style) return Promise.resolve(style);
    var link = document.createElement('link');
    return new Promise(function(resolve, reject) {
        link.onload = function() {
            return resolve(link.sheet);
        };
        link.onerror = function(_1, _2, _3, _4, error) {
            return reject(error);
        };
        Object.assign(link, options);
        link.rel = (alternate ? 'alternate ' : '') + 'stylesheet';
        link.href = URI;
        document.head.append(link);
    });
}
function $9046fa14dd22ab7f$export$5100419dfae0456d(data) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, indent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '    ';
    var padding = indent.repeat(depth);
    return Object.entries(data).map(function(param) {
        var _param = (0, $8uLkp$swchelperscjs_sliced_to_arraycjs._)(param, 2), key = _param[0], value = _param[1];
        return (typeof value === "undefined" ? "undefined" : (0, $8uLkp$swchelperscjs_type_ofcjs._)(value)) !== 'object' ? "".concat(padding).concat((0, $46e29b5594bbf78d$export$3f34ca2fef821bbd)(key), ": ").concat(value, ";") : "".concat(padding).concat(key, " {\n").concat($9046fa14dd22ab7f$export$5100419dfae0456d(value, depth + 1, indent), "\n").concat(padding, "}");
    }).join('\n');
}
function $9046fa14dd22ab7f$export$28d9d24a8cd0ffc2() {
    for(var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++){
        nodes[_key] = arguments[_key];
    }
    var _fragment, _node;
    var fragment = document.createDocumentFragment();
    (_fragment = fragment).append.apply(_fragment, (0, $8uLkp$swchelperscjs_to_consumable_arraycjs._)(nodes));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $9046fa14dd22ab7f$export$5118471ee5d5453b(fragment)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var node = _step.value;
            if (![
                1,
                3,
                11
            ].includes(node.nodeType) || [
                'meta',
                'title',
                'link',
                'script'
            ].includes(node.nodeName.toLowerCase())) (_node = node).replaceWith.apply(_node, (0, $8uLkp$swchelperscjs_to_consumable_arraycjs._)(node.childNodes));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var selection = globalThis.getSelection();
    if (!selection) return;
    var range = selection.getRangeAt(0);
    range.deleteContents();
    range.insertNode(fragment);
}
function $9046fa14dd22ab7f$export$3f99968195accfaf(selector, root, align, justify) {
    var _querySelector;
    var _ref = (0, $8uLkp$swchelperscjs_sliced_to_arraycjs._)(/^#(.+)/.exec(selector) || [], 2), _ = _ref[0], ID = _ref[1];
    if (ID === 'top') window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
    else (_querySelector = (root || document).querySelector(ID ? '[id="'.concat(ID, '"]') : selector)) === null || _querySelector === void 0 ? void 0 : _querySelector.scrollIntoView({
        behavior: 'smooth',
        block: align,
        inline: justify
    });
}
function $9046fa14dd22ab7f$export$eafdbaa868ea9975(box, handler) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 6;
    return Array.from(box.querySelectorAll(Array.from(new Array(depth), function(_, index) {
        return "h".concat(++index);
    }) + ''), function(header) {
        new IntersectionObserver(function(param) {
            var _param = (0, $8uLkp$swchelperscjs_sliced_to_arraycjs._)(param, 1), item = _param[0];
            if (!item.isIntersecting) return;
            var target = item.target;
            handler({
                target: target,
                links: (0, $8uLkp$swchelperscjs_to_consumable_arraycjs._)(target.ownerDocument.querySelectorAll('[href="#'.concat(target.id, '"]')))
            });
        }).observe(header);
        if (!header.id.trim()) header.id = header.textContent.trim().replace(/\W+/g, '-');
        return {
            level: +header.tagName[1],
            id: header.id,
            text: header.textContent.trim()
        };
    });
}
function $9046fa14dd22ab7f$export$36a0c1ca2ae264fa(root, handler) {
    var last = document.visibilityState === 'visible' ? 1 : 0;
    function change(state) {
        if (state === 3 || last === 3) handler(state === 3);
        last = state;
    }
    new IntersectionObserver(function(param) {
        var _param = (0, $8uLkp$swchelperscjs_sliced_to_arraycjs._)(param, 1), isIntersecting = _param[0].isIntersecting;
        return change(isIntersecting ? last | 2 : last & 1);
    }).observe(root);
    document.addEventListener('visibilitychange', function() {
        return change(document.visibilityState === 'visible' ? last | 1 : last & 2);
    });
}
function $9046fa14dd22ab7f$export$86d7c59254d6a2c9(form) {
    var data = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = form.elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var field = _step.value;
            var name = field.name, value = field.value, checked = field.checked, defaultValue = field.defaultValue, selectedOptions = field.selectedOptions, files = field.files;
            var type = field.type;
            if (!name || value === '') continue;
            var box = type !== 'fieldset' && field.closest('fieldset');
            if (box && box !== form) continue;
            var parsedValue = value;
            switch(type){
                case 'radio':
                case 'checkbox':
                    if (checked) parsedValue = defaultValue ? (0, $e1fee001b184ad77$export$7ea17d45ecdcf634)(defaultValue) : true;
                    else continue;
                    break;
                case 'select-multiple':
                    parsedValue = Array.from(selectedOptions, function(param) {
                        var value = param.value;
                        return (0, $e1fee001b184ad77$export$7ea17d45ecdcf634)(value);
                    });
                    break;
                case 'fieldset':
                    parsedValue = $9046fa14dd22ab7f$export$86d7c59254d6a2c9(field);
                    break;
                case 'file':
                    parsedValue = files && Array.from(files);
                    break;
                case 'date':
                case 'datetime-local':
                case 'month':
                case 'hidden':
                case 'number':
                case 'range':
                case 'select-one':
                    parsedValue = (0, $e1fee001b184ad77$export$7ea17d45ecdcf634)(value);
            }
            if (name in data) data[name] = [].concat(data[name], parsedValue);
            else data[name] = !(parsedValue instanceof Array) || !(0, $46e29b5594bbf78d$export$dd1bc94b04021eeb)(parsedValue[1]) ? parsedValue : parsedValue[0];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return data;
}


var $3e7ff7d6b583c7f0$exports = {};

$parcel$export($3e7ff7d6b583c7f0$exports, "sleep", function () { return $3e7ff7d6b583c7f0$export$e772c8ff12451969; });
$parcel$export($3e7ff7d6b583c7f0$exports, "asyncLoop", function () { return $3e7ff7d6b583c7f0$export$57207d71b8c929c8; });


function $3e7ff7d6b583c7f0$export$e772c8ff12451969() {
    var seconds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    return new Promise(function(resolve) {
        return setTimeout(resolve, seconds * 1000);
    });
}
function $3e7ff7d6b583c7f0$export$57207d71b8c929c8(executor) {
    var seconds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var stop = false;
    (0, $8uLkp$swchelperscjs_async_to_generatorcjs._)(function() {
        var result;
        return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!!stop) return [
                        3,
                        4
                    ];
                    result = executor();
                    if (!(result instanceof Promise)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        result
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        $3e7ff7d6b583c7f0$export$e772c8ff12451969(seconds)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        0
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
    return function() {
        return stop = true;
    };
}


var $e62b5dd9a5407fda$exports = {};

$parcel$export($e62b5dd9a5407fda$exports, "delegate", function () { return $e62b5dd9a5407fda$export$10b1921597150314; });
$parcel$export($e62b5dd9a5407fda$exports, "documentReady", function () { return $e62b5dd9a5407fda$export$3e2b244719956741; });
$parcel$export($e62b5dd9a5407fda$exports, "promisify", function () { return $e62b5dd9a5407fda$export$1d1d2ed6b55cf67f; });
$parcel$export($e62b5dd9a5407fda$exports, "createMessageServer", function () { return $e62b5dd9a5407fda$export$2155c0b5a4b77fb8; });
$parcel$export($e62b5dd9a5407fda$exports, "createMessageClient", function () { return $e62b5dd9a5407fda$export$9d97473344489dfc; });
$parcel$export($e62b5dd9a5407fda$exports, "serviceWorkerUpdate", function () { return $e62b5dd9a5407fda$export$d635d04af3887bbe; });






function $e62b5dd9a5407fda$export$10b1921597150314(selector, handler) {
    return function(event) {
        var node, path = event.composedPath();
        while((node = path.shift()) && node !== event.currentTarget)if (node instanceof HTMLElement && node.matches(selector)) return handler.call(this, event, node, event.detail);
    };
}
var $e62b5dd9a5407fda$export$3e2b244719956741 = typeof window !== 'undefined' ? new Promise(function(resolve) {
    var _document;
    function done() {
        var _document;
        (_document = document) === null || _document === void 0 ? void 0 : _document.removeEventListener('DOMContentLoaded', done);
        window.removeEventListener('load', done);
        resolve();
    }
    (_document = document) === null || _document === void 0 ? void 0 : _document.addEventListener('DOMContentLoaded', done);
    window.addEventListener('load', done);
    setTimeout(function check() {
        var _document;
        ((_document = document) === null || _document === void 0 ? void 0 : _document.readyState) === 'complete' ? resolve() : setTimeout(check);
    });
}) : Promise.resolve();
function $e62b5dd9a5407fda$export$1d1d2ed6b55cf67f(scope, element) {
    return new Promise(function(resolve, reject) {
        function end(event) {
            resolve(event), clean();
        }
        function cancel(event) {
            reject(event), clean();
        }
        function clean() {
            element.removeEventListener(scope + 'end', end);
            element.removeEventListener(scope + 'cancel', cancel);
        }
        element.addEventListener(scope + 'end', end);
        element.addEventListener(scope + 'cancel', cancel);
    });
}
function $e62b5dd9a5407fda$export$2155c0b5a4b77fb8(handlers) {
    function server(_param) {
        return _server.apply(this, arguments);
    }
    function _server() {
        _server = (0, $8uLkp$swchelperscjs_async_to_generatorcjs._)(function(_param) {
            var _param_data, type, id, source, origin, data, _handlers_type, result;
            return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _param_data = _param.data, type = _param_data.type, id = _param_data.id, source = _param.source, origin = _param.origin, data = (0, $8uLkp$swchelperscjs_object_without_propertiescjs._)(_param.data, [
                            "type",
                            "id"
                        ]);
                        result = (_handlers_type = handlers[type]) === null || _handlers_type === void 0 ? void 0 : _handlers_type.call(handlers, data);
                        if (!(result instanceof Promise)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            result
                        ];
                    case 1:
                        result = _state.sent();
                        _state.label = 2;
                    case 2:
                        // @ts-ignore
                        source.postMessage((0, $8uLkp$swchelperscjs_object_spread_propscjs._)((0, $8uLkp$swchelperscjs_object_spreadcjs._)({}, result), {
                            id: id
                        }), origin);
                        return [
                            2
                        ];
                }
            });
        });
        return _server.apply(this, arguments);
    }
    globalThis.addEventListener('message', server);
    return function() {
        return globalThis.removeEventListener('message', server);
    };
}
function $e62b5dd9a5407fda$export$9d97473344489dfc(target) {
    var origin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '*';
    return function(type, data) {
        return new Promise(function(resolve) {
            var UID = (0, $46e29b5594bbf78d$export$89912e019eef22aa)();
            function handler(_param) {
                var id = _param.data.id, _$data = (0, $8uLkp$swchelperscjs_object_without_propertiescjs._)(_param.data, [
                    "id"
                ]);
                if (id !== UID) return;
                resolve(_$data);
                globalThis.removeEventListener('message', handler);
            }
            globalThis.addEventListener('message', handler);
            // @ts-ignore
            target.postMessage((0, $8uLkp$swchelperscjs_object_spreadcjs._)({
                id: UID,
                type: type
            }, data), origin);
        });
    };
}
function $e62b5dd9a5407fda$export$d635d04af3887bbe(registration) {
    return new Promise(function(resolve) {
        if (registration.waiting) return resolve(registration.waiting);
        registration.onupdatefound = function() {
            var _registration_installing;
            return (_registration_installing = registration.installing) === null || _registration_installing === void 0 ? void 0 : _registration_installing.addEventListener('statechange', function() {
                if (this.state === 'installed' && navigator.serviceWorker.controller) resolve(this);
            });
        };
    });
}


var $32d670e9a1eb72ef$exports = {};

$parcel$export($32d670e9a1eb72ef$exports, "PageVector", function () { return $32d670e9a1eb72ef$export$1b88f6b6d432a52a; });
$parcel$export($32d670e9a1eb72ef$exports, "getSwipeVector", function () { return $32d670e9a1eb72ef$export$b70f6380221b1350; });
$parcel$export($32d670e9a1eb72ef$exports, "durationOf", function () { return $32d670e9a1eb72ef$export$75d6cbe4503e149; });
$parcel$export($32d670e9a1eb72ef$exports, "watchMotion", function () { return $32d670e9a1eb72ef$export$b2618d51188815c2; });
$parcel$export($32d670e9a1eb72ef$exports, "transitIn", function () { return $32d670e9a1eb72ef$export$490814474ddbb428; });
$parcel$export($32d670e9a1eb72ef$exports, "animateIn", function () { return $32d670e9a1eb72ef$export$3ea201dffb50dfef; });
$parcel$export($32d670e9a1eb72ef$exports, "transitOut", function () { return $32d670e9a1eb72ef$export$d1012c7198c6b460; });
$parcel$export($32d670e9a1eb72ef$exports, "animateOut", function () { return $32d670e9a1eb72ef$export$a35a418b7b17958e; });





var $32d670e9a1eb72ef$export$1b88f6b6d432a52a = /*#__PURE__*/ function() {
    "use strict";
    function PageVector(from, to) {
        (0, $8uLkp$swchelperscjs_class_call_checkcjs._)(this, PageVector);
        this.from = from;
        this.to = to;
    }
    (0, $8uLkp$swchelperscjs_create_classcjs._)(PageVector, [
        {
            key: "length",
            get: function get() {
                var _this = this, from = _this.from, to = _this.to;
                return Math.sqrt(Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2) + (to.z != null ? Math.pow(to.z - from.z, 2) : 0));
            }
        },
        {
            key: "direction",
            get: function get() {
                var _this = this, from = _this.from, to = _this.to;
                var XD = to.x - from.x, YD = to.y - from.y, ZD = to.z - from.z;
                var XL = Math.abs(XD), YL = Math.abs(YD), ZL = Math.abs(ZD);
                switch(isNaN(ZL) ? Math.max(XL, YL) : Math.max(XL, YL, ZL)){
                    case XL:
                        return XD > 0 ? 'right' : 'left';
                    case YL:
                        return YD > 0 ? 'forward' : 'backward';
                    case ZL:
                        return ZD > 0 ? 'up' : 'down';
                }
            }
        }
    ]);
    return PageVector;
}();
function $32d670e9a1eb72ef$export$b70f6380221b1350(from, to) {
    var threshold = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : parseInt(getComputedStyle(document.body).fontSize) * 6;
    var _getSelection;
    var vector = new $32d670e9a1eb72ef$export$1b88f6b6d432a52a(from, to);
    if (vector.length >= threshold && !((_getSelection = getSelection()) === null || _getSelection === void 0 ? void 0 : _getSelection.toString().trim())) return vector;
}
function $32d670e9a1eb72ef$export$75d6cbe4503e149(type, element) {
    var _getComputedStyle = getComputedStyle(element), transitionDuration = _getComputedStyle.transitionDuration, animationDuration = _getComputedStyle.animationDuration;
    var duration = type === 'animation' ? animationDuration : transitionDuration;
    return parseFloat(duration) * (duration.slice(-2) === 'ms' ? 1 : 1000);
}
function $32d670e9a1eb72ef$export$b2618d51188815c2(type, element) {
    return Promise.race([
        (0, $e62b5dd9a5407fda$export$1d1d2ed6b55cf67f)(type, element).catch(function(event) {
            return Promise.resolve(event);
        }),
        new Promise(function(resolve) {
            return setTimeout(resolve, $32d670e9a1eb72ef$export$75d6cbe4503e149(type, element));
        })
    ]);
}
function $32d670e9a1eb72ef$var$fadeIn(type, element, className, display) {
    element.style.display = display;
    var end = $32d670e9a1eb72ef$export$b2618d51188815c2(type, element);
    return new Promise(function(resolve) {
        return requestAnimationFrame(function() {
            element.classList.add(className);
            end.then(resolve);
        });
    });
}
function $32d670e9a1eb72ef$var$fadeOut(type, element, className, remove) {
    return $32d670e9a1eb72ef$var$_fadeOut.apply(this, arguments);
}
function $32d670e9a1eb72ef$var$_fadeOut() {
    $32d670e9a1eb72ef$var$_fadeOut = (0, $8uLkp$swchelperscjs_async_to_generatorcjs._)(function(type, element, className, remove) {
        var end;
        return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = $32d670e9a1eb72ef$export$b2618d51188815c2(type, element);
                    element.classList.remove(className);
                    return [
                        4,
                        end
                    ];
                case 1:
                    _state.sent();
                    if (remove) element.remove();
                    else element.style.display = 'none';
                    return [
                        2
                    ];
            }
        });
    });
    return $32d670e9a1eb72ef$var$_fadeOut.apply(this, arguments);
}
function $32d670e9a1eb72ef$export$490814474ddbb428(element, className) {
    var display = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'block';
    return $32d670e9a1eb72ef$var$fadeIn('transition', element, className, display);
}
function $32d670e9a1eb72ef$export$3ea201dffb50dfef(element, className) {
    var display = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'block';
    return $32d670e9a1eb72ef$var$fadeIn('animation', element, className, display);
}
function $32d670e9a1eb72ef$export$d1012c7198c6b460(element, className, remove) {
    return $32d670e9a1eb72ef$var$fadeOut('transition', element, className, remove);
}
function $32d670e9a1eb72ef$export$a35a418b7b17958e(element, className, remove) {
    return $32d670e9a1eb72ef$var$fadeOut('animation', element, className, remove);
}


var $8c91d5dd9d32cf89$exports = {};

$parcel$export($8c91d5dd9d32cf89$exports, "describe", function () { return $8c91d5dd9d32cf89$export$cd5450f3a47e3789; });
$parcel$export($8c91d5dd9d32cf89$exports, "it", function () { return $8c91d5dd9d32cf89$export$3486a10f30cf1ee4; });



function $8c91d5dd9d32cf89$export$cd5450f3a47e3789(title, cases) {
    return $8c91d5dd9d32cf89$var$_describe.apply(this, arguments);
}
function $8c91d5dd9d32cf89$var$_describe() {
    $8c91d5dd9d32cf89$var$_describe = (0, $8uLkp$swchelperscjs_async_to_generatorcjs._)(function(title, cases) {
        return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    console.log(title);
                    console.time(title);
                    return [
                        4,
                        cases()
                    ];
                case 1:
                    _state.sent();
                    console.timeEnd(title);
                    return [
                        2
                    ];
            }
        });
    });
    return $8c91d5dd9d32cf89$var$_describe.apply(this, arguments);
}
function $8c91d5dd9d32cf89$export$3486a10f30cf1ee4(title, userCase) {
    return $8c91d5dd9d32cf89$var$_it.apply(this, arguments);
}
function $8c91d5dd9d32cf89$var$_it() {
    $8c91d5dd9d32cf89$var$_it = (0, $8uLkp$swchelperscjs_async_to_generatorcjs._)(function(title, userCase) {
        var secondsOut;
        var _arguments = arguments;
        function timeOut() {
            return _timeOut.apply(this, arguments);
        }
        function _timeOut() {
            _timeOut = (0, $8uLkp$swchelperscjs_async_to_generatorcjs._)(function() {
                return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0, $3e7ff7d6b583c7f0$export$e772c8ff12451969)(secondsOut)
                            ];
                        case 1:
                            _state.sent();
                            throw new RangeError('Timed out');
                    }
                });
            });
            return _timeOut.apply(this, arguments);
        }
        return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    secondsOut = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 3;
                    title = '    ' + title;
                    console.time(title);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        3,
                        4
                    ]);
                    return [
                        4,
                        Promise.race([
                            userCase(function(status) {
                                return console.assert(status, title);
                            }),
                            timeOut()
                        ])
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    console.timeEnd(title);
                    return [
                        7
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $8c91d5dd9d32cf89$var$_it.apply(this, arguments);
}


$parcel$exportWildcard(module.exports, $46e29b5594bbf78d$exports);
$parcel$exportWildcard(module.exports, $5c284d0f856bcfdb$exports);
$parcel$exportWildcard(module.exports, $2f62b288a8aa0302$exports);
$parcel$exportWildcard(module.exports, $e1fee001b184ad77$exports);
$parcel$exportWildcard(module.exports, $c935a86b3659bb42$exports);
$parcel$exportWildcard(module.exports, $5b42b1dfba5d48a1$exports);
$parcel$exportWildcard(module.exports, $7ca3f16dcbfed4a9$exports);
$parcel$exportWildcard(module.exports, $9046fa14dd22ab7f$exports);
$parcel$exportWildcard(module.exports, $3e7ff7d6b583c7f0$exports);
$parcel$exportWildcard(module.exports, $e62b5dd9a5407fda$exports);
$parcel$exportWildcard(module.exports, $32d670e9a1eb72ef$exports);
$parcel$exportWildcard(module.exports, $8c91d5dd9d32cf89$exports);


//# sourceMappingURL=index.js.map
